import copyText from './common/copyText'

export default function directive(app: any): void {
  app.directive('copyText', copyText)
}
